import { Th } from './styles';

export const TableHeader = ({ children }) => (
    <Th>
        <b>{children}</b>
    </Th>
);
